import clsx from 'clsx';

import styles from './RatioIndicator.module.scss';

export type IndicatorColor = 'bullish' | 'bearish';

const INDICATOR_RADIUS = 8;
const INDICATOR_CIRCUMFERENCE = 2 * Math.PI * INDICATOR_RADIUS;

interface RatioIndicatorProps {
  indicator: IndicatorColor;
  ratio: number;
  className?: string;
}

export const RatioIndicator = ({
  indicator,
  ratio,
  className,
}: RatioIndicatorProps) => (
  <svg className={className} viewBox="0 0 20 20" role="presentation">
    <circle
      className={clsx(
        styles.indicatorSegment,
        indicator === 'bullish' ? styles.bearish : styles.bullish
      )}
      cx="10"
      cy="10"
      r={INDICATOR_RADIUS}
    />
    <circle
      className={clsx(styles.indicatorSegment, styles[indicator])}
      cx="10"
      cy="10"
      r={INDICATOR_RADIUS}
      strokeDasharray={`${
        (ratio / 100) * INDICATOR_CIRCUMFERENCE
      } ${INDICATOR_CIRCUMFERENCE}`}
      transform="rotate(-90 10 10)"
    />
  </svg>
);
